import { Component, Output, Input, EventEmitter, OnInit, OnDestroy, ElementRef, ViewChild, AfterViewInit, Directive } from '@angular/core'
import { DatePipe } from '@angular/common'
import { Router } from '@angular/router'
import { AddressDB } from '../../../user-management/models/address'
import { EnrollmentElectionType } from '../../models/enrollment-election-type'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { UserAccessGateway } from '../../../common/gateways/user-access-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { Step2Model } from '../../models/Step2Model'
import { BeneficiaryInfo } from '../../models/enrollments'
import { PaymentAccount } from '../../models/payment-account'
import { FormValidationService } from '../../../validations/form-validation-service'
import { ValidatedSelectOptionModel as State } from '../../../validations/validated-dropdown.component'
import { LicenseApptGateway } from '../../../user-management/gateways/license-appt-gateway'
import { License } from '../../../user-management/models/license-details'
import { StateGateway } from '../../../common/gateways/state-gateway'
import { ActivatedRoute, Params } from '@angular/router'
import { EnrollmentField, EnrollmentFieldEapp, EnrollmentFieldCodes } from '../../models/enrollment-field'
import { ValidatedRadioButtonModel } from '../../../validations/validated-radio-button-group.component'
import { CurrentUserGateway } from '../../../common/gateways/current-user-gateway'
import { CurrentUser } from '../../../common/models/current-user'
import { PortalGlobals } from '../../../portalglobals'
import { SubmitEnrollmentDataResponse } from '../../models/submit-enrollment-data-response'
import { PaymentOption, PaymentOptions } from '../../models/payment-options'
import * as moment from 'moment'
import { DrugPlan } from '../../models/drug-plan'
import { Notes } from '../../models/notes'
import { ValidAgent } from '../../models/valid-agent'
import { EmailAddressTextFieldValidator } from '../../../validations/email-address-text-field-validator'
import { NotBlankGenericFieldValidator } from '../../../validations/not-blank-generic-field-validator'
import { BeneficiaryInformationComponent } from '../common/beneficiary-information.component'
import { PrescriptionDrug } from '../common/prescription-drug-component'
import { ExternalEnrollmentFieldCodes } from '../../models/ExternalEnrollmentFieldCodes'
import { EnrollmentSettingModel } from '../../../enrollment/models/EnrollmentSettingModel'
import { EnrollmentHeader } from '../../models/EnrollmentHeader'
import { isMMDDYYYY } from '../../../validations/is-mmddyyyy'
import { TrainingCertificatesGateway } from '../../../training/gateways/training-certificates-gateway'
import { GoodStandingModel } from '../../../common/models/good-standing-model'
import { UserDataService } from '../../../user-management/gateways/user-data-service'
import { CommonGateway } from '../../../common/gateways/common-gateway'
import { ElectionPeriodComponent } from '../common/election-period.component'
import { RaceEthnicityComponent } from '../common/race-ethnicity.component'
import { AccessibilityComponent } from '../common/accessibility.component'
@Component({
    selector: 'EAppEnrollment',
    templateUrl: 'e-app-enrollment.component.html',
    providers: [DatePipe]
})
export class EAppEnrollmentComponent implements OnInit, OnDestroy, AfterViewInit {
    private _raceEthnicityComponent: RaceEthnicityComponent
    disabled: boolean = false
    correction: boolean = false
    orgID = '9'
    userProfileID: number = 0
    enrollment: BeneficiaryInfo = {} as BeneficiaryInfo
    enrollmentElectionTypes: EnrollmentElectionType[] = [new EnrollmentElectionType()]
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    goBackEnrllViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    goodStandingValues: GoodStandingModel = {} as GoodStandingModel
    step2Model: Step2Model = {} as Step2Model
    drugPlanModel = {} as DrugPlan
    reasonCode = ''
    periodSelected = ''
    genderOption = ''
    paymentMethod: typeof PaymentOptions
    residentialAddress: AddressDB = {} as AddressDB
    mailingAddress: AddressDB = {} as AddressDB
    states: State[] = [] as State[]
    licenses: License[] = [] as License[]
    paymentOption: string = ''
    paymentAccount: PaymentAccount = {} as PaymentAccount
    private uniqueLink: string
    @Output() onValueChange: EventEmitter<BeneficiaryInfo> = new EventEmitter<BeneficiaryInfo>()
    currentUser: CurrentUser
    AGENTID: string
    PLANYEAR: number
    hasError: boolean
    appDate: string
    status: string
    ErrorMessages: any[]
    pagestatus: string
    notesModel = {} as Notes
    AGENTORGID: number
    allStates: State[] = [] as State[]
    isValidAgent: boolean
    validAgentModel: ValidAgent
    AdminID: number
    CUID: string
    AgentID: string
    emailLabel: string
    dateField: boolean
    @ViewChild('focusableEleTop') focusableEleTop: ElementRef
    emailAddressTextFieldValidator = new EmailAddressTextFieldValidator()
    notBlankValidator = new NotBlankGenericFieldValidator()
    PopUpShow: boolean
    emailText: string
    EOBEmaildisabled: boolean
    otherCov: string
    sameaddr: boolean
    enrollmentHeader: EnrollmentHeader = {} as EnrollmentHeader
    public loading: boolean = false
    public insuranceCompany: string
    @ViewChild(BeneficiaryInformationComponent) private child: BeneficiaryInformationComponent
    @ViewChild(PrescriptionDrug) private childOtherCov: PrescriptionDrug
    myFormattedDate: any
    eobOption: string = ''
    eobEmail: string = ''
    haserror: boolean = false
    trainingMsg: boolean = false
    backgroundMsg: boolean = false
    trainingFailedMsg: boolean = false
    licencemsg: boolean = false
    validAgent: boolean = false
    checkStatus: string
    showOtherCoverage: boolean
    SEPReasonCodeList: any[]
    InProgessFName: string
    InProgessLName: string
    disableAppRecievDt: boolean
    accessibilityValue: string
    private accessibilityComponent: AccessibilityComponent
    @ViewChild(ElectionPeriodComponent) private electperiodchild: ElectionPeriodComponent
    @ViewChild('accessibility') accessibility: AccessibilityComponent
    isEOB: boolean

    constructor(
        private _enrollmentGateway: EnrollmentGateway,
        private _userAccessGateway: UserAccessGateway,
        protected formValidationService: FormValidationService,
        private router: Router,
        private _licenseAppGateway: LicenseApptGateway,
        private _stateGateway: StateGateway,
        private route: ActivatedRoute,
        private _currentUserGateway: CurrentUserGateway,
        private trainingCertificatesGateway: TrainingCertificatesGateway,
        private _global: PortalGlobals,
        private pipe: DatePipe,
        private userdataservice: UserDataService,
        private commonGateway: CommonGateway,
        private routers: Router
    ) {
        this._raceEthnicityComponent = new RaceEthnicityComponent(this._enrollmentGateway)
        this.step2Model = {} as Step2Model
        this.step2Model.notes = {} as Notes
        this.step2Model.prescriptionDrug = {} as DrugPlan
        this.step2Model.beneficiaryInfo = {} as BeneficiaryInfo
        this.paymentMethod = {} as typeof PaymentOptions
        this.EOBEmaildisabled = true
        this.sameaddr = false
        this.SEPReasonCodeList = [] as any[]
        this.showOtherCoverage = false
        // this.accessibilityComponent = new AccessibilityComponent(this._enrollmentGateway);
        //alert("Test")
        //console.log("Test");
    }

    ngOnInit() {
        //alert("Test ng")
        //console.log("Test ng");
        //Application Received date Disabled.
        //Tyagi: Remove this after testing before deplyement
        this.disableAppRecievDt = false

        if (sessionStorage.getItem('GoodStandingParams') != null) {
            this.setPageData()
        } else {
            this.setGoodStandingStatus()
        }
    }

    setPageData() {
        this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
        if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
            this.haserror = true
            this.trainingMsg = !this.goodStandingValues.CurriculumStatus
            this.backgroundMsg = !this.goodStandingValues.BackgroundCheckStatus
            this.licencemsg = !this.goodStandingValues.LicenseStatus
        } else {
            if (this._global.currentUser !== null && this._global.currentUser !== undefined) {
                this.loadInitData()
            } else {
                this._currentUserGateway.getCurrentUser().subscribe((currentUserModel: CurrentUser) => {
                    // this.currentUser = currentUserModel
                    this._global.currentUser = currentUserModel
                    this.loadInitData()
                })
            }
        }
    }

    setGoodStandingStatus() {
        if (this._global.currentUser === undefined) {
            this._currentUserGateway.getCurrentUser().subscribe((user) => {
                if (user != null) {
                    this._global.currentUser = user
                    if (this._global.selectedPlanYear === 0) {
                        this.userdataservice.currentYear.subscribe((data) => {
                            this._global.selectedPlanYear = data
                            if (data !== undefined && data !== 0) {
                                this.setGoodStanding()
                            }
                        })
                    } else {
                        this.setGoodStanding()
                    }
                }
            })
        } else {
            this.setGoodStanding()
        }
    }

    setGoodStanding() {
        this.commonGateway.getGoodStandingDetails(this._global.currentUser.userProfileId, String(this._global.selectedPlanYear)).subscribe(
            (model: GoodStandingModel) => {
                if (model.GoodStandingStatus !== undefined && model.GoodStandingStatus !== null && model.GoodStandingStatus) {
                    sessionStorage.setItem('GoodStandingParams', JSON.stringify(model))
                } else {
                    sessionStorage.setItem('GoodStandingParams', JSON.stringify(model))
                }
                this.setPageData()
            },
            (error) => {
                console.log(error)
            }
        )
    }

    loadInitData() {
        this.validAgent = true
        this.residentialAddress = {} as AddressDB
        this.mailingAddress = {} as AddressDB
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        this.enrollmentViewModel.FORMNAME = 'EAPPLICATION'
        this.sameaddr = this.enrollmentViewModel.SAMEADDRESS
        this.enrollmentViewModel.residentialAddress = {} as AddressDB
        this.enrollmentViewModel.mailingAddress = {} as AddressDB
        // this.insuranceCompany = this._global.currentUser.insuranceCompanyName
        this.setOrgname()
        this.route.params.subscribe((params) => {
            if (params['ak'] !== undefined && params['eid'] !== undefined) {
                this.enrollmentViewModel.ACCESSKEY = params['ak']
                this.enrollmentViewModel.ENROLLMENTID = params['eid']
                this.enrollmentViewModel.ISEXTERNALAGENT = true
                this.setExternalData()
                this.enrollmentViewModel.ISEXTERNALAGENT = true
            }
        })

        if (
            this.enrollmentViewModel.historyStatus !== undefined &&
            this.enrollmentViewModel.historyStatus !== '' &&
            this.enrollmentViewModel.historyStatus !== null
        ) {
            this.checkStatus = this.enrollmentViewModel.historyStatus
        }
        //if (this.enrollmentViewModel.EOB == this.enrollmentViewModel.LANGFORMAT) {
        //    this.accessibilityValue = this.enrollmentViewModel.EOB;
        //}
        //else {
        // this.accessibilityValue = this.enrollmentViewModel.LANGFORMAT;
        // }
        this.enrollmentViewModel.accessibility = this.enrollmentViewModel.EOB
        this.setData()
        if (this.mailingAddress !== undefined && this.mailingAddress.state === undefined) {
            this.mailingAddress.state = '0'
        } else if (this.mailingAddress.state === '') {
            this.mailingAddress.state = '0'
        }
        if (this.residentialAddress !== undefined && this.residentialAddress.state === undefined) {
            this.residentialAddress.state = '0'
        } else if (this.residentialAddress.state === '') {
            this.residentialAddress.state = '0'
        }
    }

    setExternalData() {
        this.enrollmentHeader.EnrollmentID = this.enrollmentViewModel.ENROLLMENTID
        this.enrollmentHeader.accesskey = this.enrollmentViewModel.ACCESSKEY

        this.enrollment = {} as BeneficiaryInfo

        //Service call to set external data
        this._enrollmentGateway.getEnrollmentHeader(this.enrollmentHeader).subscribe((model: EnrollmentField[]) => {
            this.enrollment = {} as BeneficiaryInfo
            this.sameaddr = false
            this.SEPReasonCodeList.push(
                { value: '125', code: 'NewMedicare' },
                { value: '126', code: 'ReturnUSA' },
                { value: '128', code: 'Now65' },
                { value: '200', code: 'NewOptin' },
                { value: '201', code: 'EmployerCoverage' },
                { value: '203', code: 'StatedataEntryStep1Premium' },
                { value: '204', code: 'NoExtraHelp' },
                { value: '205', code: 'MovedLTC' },
                { value: '206', code: 'LeftPACE' },
                { value: '207', code: 'LostCoverage' },
                { value: '211', code: 'StatePAP' },
                { value: '213', code: 'LeftMedigap' },
                { value: '214', code: 'JoinedMedicareAdv' },
                { value: '215', code: 'Other' },
                { value: '218', code: 'Disenrolling' },
                { value: '219', code: 'EndContract' },
                { value: '221', code: 'NoSpecialNeedsPlan' },
                { value: '222', code: 'NoticeEligible' },
                { value: '223', code: 'LostPartB' }
            )

            for (let i = 0; i < model.length; i++) {
                if (model[i].FieldCode === EnrollmentFieldCodes.CURRENTGENDER) {
                    this.enrollmentViewModel.CURRENTGENDER = model[i].FieldValue
                }
                if (model[i].FieldCode === EnrollmentFieldCodes.CURRENTGENDEROTH) {
                    this.enrollmentViewModel.CURRENTGENDEROTH = model[i].FieldValue
                }
                if (model[i].FieldCode === EnrollmentFieldCodes.GENDERNPRONOUN) {
                    this.enrollmentViewModel.GENDERNPRONOUN = model[i].FieldValue
                }

                if (model[i].FieldCode === EnrollmentFieldCodes.GENDERNPRONOUNOTH) {
                    this.enrollmentViewModel.GENDERNPRONOUNOTH = model[i].FieldValue
                }

                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ACCHOLDERNAME) {
                    this.enrollmentViewModel.ACCHOLDERNAME = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ACCOUNTNB) {
                    this.enrollmentViewModel.ACCOUNTNB = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ROUTINGNB) {
                    this.enrollmentViewModel.ROUTINGNB = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFTTYPE) {
                    this.enrollmentViewModel.EFTTYPE = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.FININSTNAME) {
                    this.enrollmentViewModel.FININSTNAME = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.RELCD) {
                    this.enrollmentViewModel.RELCD = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANTYPE) {
                    if (model[i].FieldValue === 'C') {
                        this.enrollmentViewModel.PLANTYPE = 'CHOICE'
                    } else if (model[i].FieldValue === 'P') {
                        this.enrollmentViewModel.PLANTYPE = 'PLUS'
                    } else if (model[i].FieldValue === 'S') {
                        this.enrollmentViewModel.PLANTYPE = 'SMARTRX'
                    } else {
                        this.enrollmentViewModel.PLANTYPE = model[i].FieldValue
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPDT) {
                    if (model[i].FieldValue !== null && model[i].FieldValue !== undefined) {
                        this.enrollment.applicationDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                        this.enrollmentViewModel.APPDT = this.enrollment.applicationDate
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFFDT) {
                    this.enrollmentViewModel.EFFDT = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                    this.enrollment.effectiveEnrollmentDate = new Date(model[i].FieldValue)
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPFN) {
                    this.enrollment.firstName = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPLN) {
                    this.enrollment.lastName = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SUFFIX) {
                    this.enrollment.suffixName = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPMI) {
                    this.enrollment.middleInitial = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.TITLE) {
                    this.enrollment.title = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.HICN) {
                    this.enrollment.medicareId = model[i].FieldValue.toString().toUpperCase()
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MEDA) {
                    if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                        this.enrollment.medicarePartAEffectiveDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MEDB) {
                    if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                        this.enrollment.medicarePartBEffectiveDate = new Date(moment(model[i].FieldValue).format('MM/DD/YYYY'))
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPDOB) {
                    this.pipe = new DatePipe('en-US')
                    this.myFormattedDate = this.pipe.transform(model[i].FieldValue, 'MM/dd/yyyy')
                    this.enrollment.dateOfBirth = this.myFormattedDate
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPPHONE) {
                    this.enrollment.primaryPhone = model[i].FieldValue
                }

                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EOB) {
                    if (
                        model[i].FieldValue !== undefined &&
                        (model[i].FieldValue === 'EEOB' ||
                            model[i].FieldValue === '3' ||
                            model[i].FieldValue.toString().toUpperCase() === 'YES' ||
                            this.enrollmentViewModel.EOB === '5' ||
                            this.enrollmentViewModel.EOB === '6' ||
                            this.enrollmentViewModel.EOB === '7' ||
                            this.enrollmentViewModel.EOB === '9')
                    ) {
                        this.accessibilityValue = this.enrollmentViewModel.EOB
                        this.enrollmentViewModel.EOB = 'EEOB'
                        this.isEOB = true
                    } else if (model[i].FieldValue !== undefined && (model[i].FieldValue === 'N' || model[i].FieldValue === 'PEOB')) {
                        this.accessibilityValue = this.enrollmentViewModel.EOB
                        this.enrollmentViewModel.EOB = 'PEOB'
                        this.isEOB = false
                    } else {
                        this.enrollmentViewModel.EOB = 'PEOB'
                        this.isEOB = false
                    }

                    //this.enrollmentViewModel.EOB = model[i].FieldValue
                    //this.enrollmentViewModel.LANGFORMAT = model[i].FieldValue
                    //this.enrollmentViewModel.accessibility = this.enrollmentViewModel.EOB;
                    //if (this.enrollmentViewModel.EOB === '3' || this.enrollmentViewModel.EOB === 'EEOB'
                    //    || this.enrollmentViewModel.EOB === '5' || this.enrollmentViewModel.EOB === '6'
                    //    || this.enrollmentViewModel.EOB === '7'
                    //) {

                    //    this.enrollmentViewModel.EOB = 'EEOB'
                    //    this.isEOB = true;
                    //}
                    //else {
                    //    this.enrollmentViewModel.EOB = 'PEOB'
                    //    this.isEOB = false;
                    //}
                }

                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPGEN) {
                    //if (model[i].FieldValue === "M" || model[i].FieldValue === "MALE") {
                    //    this.enrollment.gender = "M"
                    //} else {
                    //    this.enrollment.gender = "F"
                    //}
                    this.enrollment.gender = model[i].FieldValue
                    this.enrollmentViewModel.APPGEN = model[i].FieldValue
                    this.ngAfterViewInit()
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.CELLPHONE) {
                    this.enrollment.cellPhone = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPEMAIL) {
                    this.enrollment.email = model[i].FieldValue
                    this.eobEmail = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD1) {
                    this.residentialAddress.addressLine1 = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPADD2) {
                    this.residentialAddress.addressLine2 = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPCITY) {
                    this.residentialAddress.city = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPZIP) {
                    this.residentialAddress.zip = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPST) {
                    this.residentialAddress.state = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILINGADDRESSISSAME) {
                    if (model[i].FieldValue !== undefined && model[i].FieldValue.toUpperCase() === 'TRUE') {
                        this.residentialAddress.sameAddress = true
                        this.sameaddr = true
                    } else {
                        this.residentialAddress.sameAddress = false
                        this.sameaddr = false
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LTCFACILITY) {
                    this.enrollmentViewModel.LTCFACILITY = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LTCPHONE) {
                    this.enrollmentViewModel.LTCPHONE = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.NOTES) {
                    this.enrollmentViewModel.NOTES = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPREASONCD) {
                    this.enrollmentViewModel.SEPREASONCD = Number(model[i].FieldValue)
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPEFFDT) {
                    if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                        this.enrollmentViewModel.SEPEFFDT = new Date(model[i].FieldValue)
                    } else {
                        this.enrollmentViewModel.SEPEFFDT = null
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.ELECTION) {
                    if (model[i].FieldValue === 'I') {
                        this.enrollmentViewModel.ELECTION = 'FirstTime'
                    } else if (model[i].FieldValue === 'S') {
                        this.enrollmentViewModel.ELECTION = 'Special'
                    } else {
                        this.enrollmentViewModel.ELECTION = 'OpenEnrollment'
                    }
                    this.periodSelected = this.enrollmentViewModel.ELECTION
                    //this.enrollmentViewModel.ELECTION = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILADD1) {
                    this.mailingAddress.addressLine1 = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILADD2) {
                    this.mailingAddress.addressLine2 = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILCITY) {
                    this.mailingAddress.city = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILST) {
                    this.mailingAddress.state = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.MAILZIP) {
                    this.mailingAddress.zip = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PWO) {
                    if (model[i].FieldValue === 'P') {
                        this.enrollmentViewModel.PWO = 'Direct Bill'
                    } else if (model[i].FieldValue === 'S') {
                        this.enrollmentViewModel.PWO = 'Deduction from Social Security Check'
                    } else if (model[i].FieldValue === 'R') {
                        this.enrollmentViewModel.PWO = 'Deduction from Railroad Retirement Board'
                    } else if (model[i].FieldValue === 'E') {
                        this.enrollmentViewModel.PWO = 'Automatic Bank Draft Withdrawal'
                    }
                    this.paymentOption = this.enrollmentViewModel.PWO
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.PLANYEAR) {
                    this.enrollmentViewModel.PLANYEAR = this.PLANYEAR.toString()
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANG) {
                    if (model[i].FieldValue === 'E') {
                        this.enrollmentViewModel.LANG = 'english'
                    } else {
                        this.enrollmentViewModel.LANG = 'spanish'
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRG) {
                    if (model[i].FieldValue.toString().toUpperCase() === 'TRUE') {
                        this.enrollmentViewModel.OTHCVRG = 'yes'
                        this.showOtherCoverage = true
                    } else {
                        this.enrollmentViewModel.OTHCVRG = 'no'
                        this.showOtherCoverage = false
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGGRP) {
                    this.enrollmentViewModel.OTHCVRGGRP = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGID) {
                    this.enrollmentViewModel.OTHCVRGID = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.OTHCVRGNAME) {
                    this.enrollmentViewModel.OTHCVRGNAME = model[i].FieldValue

                    //this.ngAfterViewInit()
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBBIN) {
                    this.enrollmentViewModel.COBBIN = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBEFFDT) {
                    if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                        this.enrollmentViewModel.COBEFFDT = new Date(model[i].FieldValue)
                    } else {
                        this.enrollmentViewModel.COBEFFDT = null
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBPCN) {
                    this.enrollmentViewModel.COBPCN = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.COBTERMDT) {
                    if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                        this.enrollmentViewModel.COBTERMDT = new Date(model[i].FieldValue)
                    } else {
                        this.enrollmentViewModel.COBTERMDT = null
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.APPGEN) {
                    //this.Gen = model[i].FieldValue
                    //this.child.loadGoBackData()
                    this.enrollmentViewModel.APPGEN = model[i].FieldValue
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANGFORMAT) {
                    this.enrollmentViewModel.EOB = model[i].FieldValue
                    this.eobOption = this.enrollmentViewModel.EOB
                    this.accessibilityValue = this.enrollmentViewModel.EOB
                    alert('EOB:' + this.accessibilityValue)
                    if (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob') {
                        this.eobEmail = 'Email Address'
                    }
                    //else if (this.enrollmentViewModel.EOB === '3') {
                    //    this.eobEmail = 'Email Address'
                    //}
                    else {
                        this.eobEmail = 'Email Address'
                    }
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.EFTTYPE) {
                    if (model[i].FieldValue === 'S') {
                        this.enrollmentViewModel.EFTTYPE = 'SAVINGS'
                    } else if (model[i].FieldValue === 'C') {
                        this.enrollmentViewModel.EFTTYPE = 'CHECKING'
                    }
                }
                //if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANGFORMAT) {
                //    this.enrollmentViewModel.EOB = model[i].FieldValue
                //    //this.eobOption = this.enrollmentViewModel.EOB
                //    this.enrollmentViewModel.LANGFORMAT = model[i].FieldValue
                //}
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SEPREASONCD) {
                    let selSepReasonCode = this.SEPReasonCodeList.filter((x) => x.value === model[i].FieldValue)[0]
                    if (selSepReasonCode === undefined || selSepReasonCode === null) {
                        selSepReasonCode = this.SEPReasonCodeList.filter((x) => x.code === model[i].FieldValue)[0]
                    }
                    this.enrollmentViewModel.SEPREASONCD = Number(selSepReasonCode.value)
                }
                if (model[i].FieldCode === ExternalEnrollmentFieldCodes.SOA) {
                    if (model[i].FieldValue !== undefined && model[i].FieldValue !== null) {
                        if (model[i].FieldValue.toUpperCase() === 'YES') {
                            this.enrollmentViewModel.SOA = 'Yes'
                        } else {
                            this.enrollmentViewModel.SOA = 'No'
                        }
                    }
                }
            }
            this.residentialAddress.sameAddress = this.sameaddr
            this.enrollmentViewModel.SAMEADDRESS = this.sameaddr
            this.enrollmentViewModel.residentialAddress = this.residentialAddress
            this.enrollmentViewModel.mailingAddress = this.mailingAddress
            this.enrollmentViewModel.beneficiaryInfo = this.enrollment

            this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            this.electperiodchild.onEnrollmentViewModelChange()
            this.getAllStates()

            //console.log(this.enrollmentViewModel)
            //this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        })
    }

    getAllStates() {
        if (this.states !== undefined && this.states.length > 0) {
            if (this.states.length === 1 && this.states[0].value === 0) {
                this.setExtStates()
            } else {
                this.setExternState()
            }
        } else {
            this.setExtStates()
        }
    }

    setExtStates() {
        this._stateGateway.getAllStates().subscribe((state) => {
            for (let i = 0; i < state.length; i++) {
                this.states.push({ value: state[i].value, text: state[i].text })
            }
            this.setExternState()
        })
    }

    setExternState() {
        let resState = this.states.filter((x) => x.text === this.residentialAddress.state)
        if (resState !== undefined && resState.length > 0) {
            this.residentialAddress.state = String(resState[0].value)
        }
        let mailState = this.states.filter((x) => x.text === this.mailingAddress.state)
        if (mailState !== undefined) {
            this.mailingAddress.state = String(mailState[0].value)
        }
        this.enrollmentViewModel.beneficiaryInfo = this.enrollment
        this.enrollmentViewModel.residentialAddress = this.residentialAddress
        this.enrollmentViewModel.mailingAddress = this.mailingAddress
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        this.setData()
        this.loading = false
    }

    setData() {
        this.PopUpShow = this.route.snapshot.data['popUp'] === 'true' ? true : false
        if (!this.enrollmentViewModel.ISEXTERNALAGENT) {
            this.goBackEnrllViewModel = this._enrollmentGateway.getEnrollmentViewModel()
            this.enrollmentViewModel = new EnrollmentViewModel()
            //If isExternal is false, then set ISEXTERNALAGENT as false again after model has been reseted.
            this.enrollmentViewModel.ISEXTERNALAGENT = false
        }

        let today = new Date()
        let nextMonthDt = new Date()
        if (today.getMonth() == 11) {
            nextMonthDt = new Date(today.getFullYear() + 1, 0, 1)
        } else {
            nextMonthDt = new Date(today.getFullYear(), today.getMonth() + 1, 1)
        }
        this.emailLabel = 'Email Address'
        this.isValidAgent = false

        if (this.enrollmentViewModel.ISEXTERNALAGENT !== undefined && !this.enrollmentViewModel.ISEXTERNALAGENT) {
            this.enrollmentViewModel.APPDT = today
            this.enrollment.applicationDate = today

            if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                if (nextMonthDt.getFullYear().toString() !== this._global.selectedPlanYear.toString()) {
                    if (this._global.selectedPlanYear > nextMonthDt.getFullYear()) nextMonthDt = new Date(today.getFullYear() + 1, 0, 1)
                }
            }
            this.enrollmentViewModel.EFFDT = nextMonthDt
            this.enrollment.effectiveEnrollmentDate = nextMonthDt
        }

        this.getParams()
        if (this.pagestatus === undefined && this.uniqueLink === undefined) {
            this.disabled = false
        } else if (this.pagestatus === 'verify') {
            this.disabled = true
        } else if (this.pagestatus !== null && this.pagestatus !== undefined) {
            this.disabled = false
            this.enrollmentViewModel.historyStatus = this.pagestatus
        } else if (this.checkStatus !== undefined && this.checkStatus !== '' && this.checkStatus !== null) {
            this.enrollmentViewModel.historyStatus = this.checkStatus
        }

        if (this.enrollmentViewModel.historyStatus !== undefined || this.enrollmentViewModel.historyStatus !== 'In Progress') {
            this.AGENTID = this._global.currentUser.userProfileId.toString()
            this.enrollmentViewModel.AGENTORGID = Number(this._global.currentUser.orgId)
            this.enrollmentViewModel.AGENTNAME = this._global.currentUser.firstName + ' ' + this._global.currentUser.lastName //this._global.currentUser.userProfileName

            console.log('data model:' + this.enrollmentViewModel)
            console.log('data model CUID:' + this.enrollmentViewModel.CUID)
        }
        this.PLANYEAR = this._global.selectedPlanYear

        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)

        this._stateGateway.getAllStates().subscribe((states: State[]) => (this.allStates = states))
        this._licenseAppGateway.getUserLicenseDetailsForEnrollment(this._global.currentUser.userProfileName).subscribe((state) => {
            for (let i = 0; i < state.length; i++) {
                this.states.push({ value: state[i].value, text: state[i].text })
            }
        })
        this.states.unshift({ value: 0, text: '-- Choose One --' })

        if (this.uniqueLink !== null && this.uniqueLink !== undefined) {
            this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
            this._enrollmentGateway.getEnrollmentAppDetails(this.uniqueLink).subscribe((model: EnrollmentFieldEapp[]) => {
                for (let i = 0; i < model.length; i++) {
                    if (model[i].FieldCode === EnrollmentFieldCodes.CURRENTGENDER) {
                        this.enrollmentViewModel.CURRENTGENDER = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.CURRENTGENDEROTH) {
                        this.enrollmentViewModel.CURRENTGENDEROTH = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.GENDERNPRONOUN) {
                        this.enrollmentViewModel.GENDERNPRONOUN = model[i].FieldValue
                    }

                    if (model[i].FieldCode === EnrollmentFieldCodes.GENDERNPRONOUNOTH) {
                        this.enrollmentViewModel.GENDERNPRONOUNOTH = model[i].FieldValue
                    }

                    if (model[i].FieldCode === EnrollmentFieldCodes.ETHNICITY) {
                        this.enrollmentViewModel.Ethnicity = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.RACE) {
                        this.enrollmentViewModel.Race = model[i].FieldValue
                    }

                    if (model[i].FieldCode === EnrollmentFieldCodes.AGENTFN) {
                        this.enrollmentViewModel.AGENTNAME = model[i].FieldValue
                        this.InProgessFName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.AGENTLN) {
                        this.enrollmentViewModel.AGENTNAME = this.enrollmentViewModel.AGENTNAME + ' ' + model[i].FieldValue
                        this.InProgessLName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.ACCHOLDERNAME) {
                        this.enrollmentViewModel.ACCHOLDERNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.ACCOUNTNB) {
                        this.enrollmentViewModel.ACCOUNTNB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.ROUTINGNB) {
                        this.enrollmentViewModel.ROUTINGNB = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.EFTTYPE) {
                        this.enrollmentViewModel.EFTTYPE = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.FININSTNAME) {
                        this.enrollmentViewModel.FININSTNAME = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.ELECTION) {
                        this.enrollmentViewModel.ELECTION = model[i].FieldValue
                        this.periodSelected = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.PLANTYPE) {
                        this.enrollmentViewModel.PLANTYPE = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPDT) {
                        if (model[i].FieldValue !== null && model[i].FieldValue !== undefined) {
                            this.enrollment.applicationDate = new Date(model[i].FieldValue)
                            this.enrollmentViewModel.APPDT = this.enrollment.applicationDate
                        }
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.EFFDT) {
                        this.enrollmentViewModel.EFFDT = new Date(model[i].FieldValue)
                        this.enrollment.effectiveEnrollmentDate = new Date(model[i].FieldValue)
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPFN) {
                        this.enrollment.firstName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPLN) {
                        this.enrollment.lastName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.SUFFIX) {
                        this.enrollment.suffixName = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPMI) {
                        this.enrollment.middleInitial = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.TITLE) {
                        this.enrollment.title = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.HICN) {
                        this.enrollment.medicareId = model[i].FieldValue.toString().toUpperCase()
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MEDA) {
                        if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                            this.enrollment.medicarePartAEffectiveDate = new Date(model[i].FieldValue)
                        }
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MEDB) {
                        if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                            this.enrollment.medicarePartBEffectiveDate = new Date(model[i].FieldValue)
                        }
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPDOB) {
                        this.pipe = new DatePipe('en-US')
                        this.myFormattedDate = this.pipe.transform(model[i].FieldValue, 'MM/dd/yyyy')
                        this.enrollment.dateOfBirth = this.myFormattedDate
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPPHONE) {
                        this.enrollment.primaryPhone = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPGEN) {
                        //if (model[i].FieldValue === "M" || model[i].FieldValue === "MALE") {
                        //    this.enrollment.gender = "M"
                        //} else {
                        //    this.enrollment.gender = "F"
                        //}
                        this.enrollment.gender = model[i].FieldValue
                        this.enrollmentViewModel.APPGEN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.CELLPHONE) {
                        this.enrollment.cellPhone = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPEMAIL) {
                        this.enrollment.email = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPADD1) {
                        this.residentialAddress.addressLine1 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPADD2) {
                        this.residentialAddress.addressLine2 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPCITY) {
                        this.residentialAddress.city = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPZIP) {
                        this.residentialAddress.zip = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.APPST) {
                        this.residentialAddress.state = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.LTCFACILITY) {
                        this.enrollmentViewModel.LTCFACILITY = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.LTCPHONE) {
                        this.enrollmentViewModel.LTCPHONE = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.NOTES) {
                        this.enrollmentViewModel.NOTES = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.SEPREASONCD) {
                        this.enrollmentViewModel.SEPREASONCD = Number(model[i].FieldValue)
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.SEPEFFDT) {
                        if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                            this.enrollmentViewModel.SEPEFFDT = new Date(model[i].FieldValue)
                        } else {
                            this.enrollmentViewModel.SEPEFFDT = null
                        }
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.ELECTION) {
                        this.enrollmentViewModel.ELECTION = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MAILADD1) {
                        this.mailingAddress.addressLine1 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MAILADD2) {
                        this.mailingAddress.addressLine2 = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MAILCITY) {
                        this.mailingAddress.city = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MAILST) {
                        this.mailingAddress.state = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.MAILZIP) {
                        this.mailingAddress.zip = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.PWO) {
                        this.enrollmentViewModel.PWO = model[i].FieldValue
                        this.paymentOption = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.AGENTID) {
                        this.enrollmentViewModel.AGENTID = model[i].FieldValue

                        this.enrollmentViewModel.AGENTORGID = Number(model[i].OrgID)
                        this.AGENTID = model[i].FieldValue
                        this.AGENTORGID = Number(model[i].OrgID)
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.PLANYEAR) {
                        this.enrollmentViewModel.PLANYEAR = this.PLANYEAR.toString()
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.LANG) {
                        this.enrollmentViewModel.LANG = model[i].FieldValue
                    }
                    //if (model[i].FieldCode === EnrollmentFieldCodes.OTHCVRG) {

                    //    this.otherCov = model[i].FieldValue
                    //    this.enrollmentViewModel.OTHCVRG = model[i].FieldValue

                    //    //this.ngAfterViewInit()
                    //}

                    if (model[i].FieldCode === EnrollmentFieldCodes.OTHCVRG) {
                        if (model[i].FieldValue !== null || model[i].FieldValue !== undefined) {
                            if (model[i].FieldValue.toString().toUpperCase() === 'YES') {
                                this.enrollmentViewModel.OTHCVRG = 'yes'
                                this.showOtherCoverage = true
                            } else {
                                this.enrollmentViewModel.OTHCVRG = 'no'
                                this.showOtherCoverage = false
                            }
                        }
                    }

                    if (model[i].FieldCode === EnrollmentFieldCodes.OTHCVRGGRP) {
                        this.enrollmentViewModel.OTHCVRGGRP = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.OTHCVRGID) {
                        this.enrollmentViewModel.OTHCVRGID = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.OTHCVRGNAME) {
                        this.enrollmentViewModel.OTHCVRGNAME = model[i].FieldValue

                        //this.ngAfterViewInit()
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.COBBIN) {
                        this.enrollmentViewModel.COBBIN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.COBEFFDT) {
                        if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                            this.enrollmentViewModel.COBEFFDT = new Date(model[i].FieldValue)
                        } else {
                            this.enrollmentViewModel.COBEFFDT = null
                        }
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.COBPCN) {
                        this.enrollmentViewModel.COBPCN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.COBTERMDT) {
                        if (model[i].FieldValue !== '' && model[i].FieldValue !== undefined) {
                            this.enrollmentViewModel.COBTERMDT = new Date(model[i].FieldValue)
                        } else {
                            this.enrollmentViewModel.COBTERMDT = null
                        }
                    }

                    if (model[i].FieldCode === EnrollmentFieldCodes.APPGEN) {
                        //this.Gen = model[i].FieldValue
                        //this.child.loadGoBackData()
                        this.enrollmentViewModel.APPGEN = model[i].FieldValue
                    }
                    if (model[i].FieldCode === ExternalEnrollmentFieldCodes.LANGFORMAT) {
                        this.enrollmentViewModel.EOB = model[i].FieldValue
                        this.enrollmentViewModel.LANGFORMAT = model[i].FieldValue
                        this.setAccessibility(this.enrollmentViewModel.EOB)
                        if (
                            this.enrollmentViewModel.EOB === '3' ||
                            this.enrollmentViewModel.EOB === 'EEOB' ||
                            this.enrollmentViewModel.EOB === '5' ||
                            this.enrollmentViewModel.EOB === '6' ||
                            this.enrollmentViewModel.EOB === '7' ||
                            this.enrollmentViewModel.EOB === '9'
                        ) {
                            this.enrollmentViewModel.EOB = 'EEOB'
                            this.isEOB = true
                        } else {
                            this.enrollmentViewModel.EOB = 'PEOB'
                            this.isEOB = false
                        }
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.AGENTSIGNATURE) {
                        this.enrollmentViewModel.AgentSignature = model[i].FieldValue
                    }
                    if (model[i].FieldCode === EnrollmentFieldCodes.SOA) {
                        if (model[i].FieldValue !== undefined && model[i].FieldValue !== null) {
                            if (model[i].FieldValue.toUpperCase() === 'YES') {
                                this.enrollmentViewModel.SOA = 'Yes'
                            } else if (model[i].FieldValue.toUpperCase() === 'NO') {
                                this.enrollmentViewModel.SOA = 'No'
                            } else {
                                this.enrollmentViewModel.SOA = this.goBackEnrllViewModel.SOA
                            }
                        } else {
                            this.enrollmentViewModel.SOA = this.goBackEnrllViewModel.SOA
                        }
                    }
                }
                this.residentialAddress.sameAddress = this.sameaddr
                this.enrollmentViewModel.SAMEADDRESS = this.sameaddr
                this.enrollmentViewModel.residentialAddress = this.residentialAddress
                this.enrollmentViewModel.mailingAddress = this.mailingAddress
                this.enrollmentViewModel.beneficiaryInfo = this.enrollment
                this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                this.electperiodchild.onEnrollmentViewModelChange()
            })
        } else {
            // }
            this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
            this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
            this.periodSelected = this.enrollmentViewModel.ELECTION
            this.residentialAddress = this.enrollmentViewModel.residentialAddress
            this.mailingAddress = this.enrollmentViewModel.mailingAddress
            this.enrollment = this.enrollmentViewModel.beneficiaryInfo
            this.paymentOption = this.enrollmentViewModel.PWO
            this.paymentAccount = this.enrollmentViewModel.paymentAccount
            this.enrollmentViewModel.PLANYEAR = this.PLANYEAR.toString()
        }
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
            this.pagestatus = this.route.snapshot.params['id']
        })
    }
    onNotify(message: boolean): void {
        this.PopUpShow = message
    }
    sepdatechange(option: Date) {
        this.enrollmentViewModel.SEPEFFDT = option
    }

    updateEnrollment(field: string, value: any) {
        this.enrollment[field] = value
        this.onValueChange.emit(this.enrollment)
    }

    reasonCodeChanged(SelReasonCode: any) {
        //  this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        //  this.reasonCode = this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.enrollmentViewModel.SEPREASONTEXT = SelReasonCode.text
        this.enrollmentViewModel.ELECTIONTYPEID = SelReasonCode.id
        this.enrollmentViewModel.SEPREASONCD = SelReasonCode.value
        this.reasonCode = this.enrollmentViewModel.ELECTIONTYPEID + '|' + this.enrollmentViewModel.SEPREASONCD
        this.reasonCode = SelReasonCode.id + '|' + SelReasonCode.value
    }
    hasDateField(datefield: boolean) {
        this.dateField = datefield
    }

    periodSelectdChanged(period: string) {
        if (this.enrollmentViewModel.ELECTION !== period) {
            this.enrollmentViewModel.SEPEFFDT = null
            this.enrollmentViewModel.SEPREASONTEXT = ''
            this.reasonCode = ''
        }
        this.periodSelected = this.enrollmentViewModel.ELECTION = period
        let currDate = new Date()

        if (this.periodSelected === 'OpenEnrollment') {
            if (this.enrollmentViewModel.EFFDT != new Date(currDate.getFullYear() + 1, 0, 1)) {
                if (currDate.getMonth() > 3) this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
            }
        } else {
            //If application is inprogress, correction, then do not set default effective date.
            if (
                this.enrollmentViewModel.ISEXTERNALAGENT !== undefined &&
                !this.enrollmentViewModel.ISEXTERNALAGENT &&
                (this.enrollmentViewModel.UNIQUELINK === undefined || this.enrollmentViewModel.UNIQUELINK === '')
            ) {
                if (currDate.getMonth() == 11) {
                    this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                } else {
                    this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)
                }

                //If Year of Effective Date is not same as that of selected plan Year, default effective date will be 01/01 of next year
                if (this._global.selectedPlanYear !== undefined && this._global.selectedPlanYear !== 0) {
                    if (this.enrollmentViewModel.EFFDT.getFullYear().toString() !== this._global.selectedPlanYear.toString()) {
                        if (this._global.selectedPlanYear > currDate.getFullYear())
                            this.enrollmentViewModel.EFFDT = new Date(currDate.getFullYear() + 1, 0, 1)
                    }
                }
            }
        }
    }

    residentialAddressChanged(address: AddressDB) {
        this.residentialAddress = this.enrollmentViewModel.residentialAddress = address
    }

    mailingAddressChanged(address: AddressDB) {
        this.residentialAddress.sameAddress = address.sameAddress
        this.enrollmentViewModel.SAMEADDRESS = address.sameAddress
        this.mailingAddress = this.enrollmentViewModel.mailingAddress = address
    }

    //change(enrollment: BeneficiaryInfo) {
    //    this.enrollment = this.enrollmentViewModel.beneficiaryInfo = enrollment
    //}
    change(enrollment: BeneficiaryInfo) {
        this.enrollmentViewModel.beneficiaryInfo = enrollment
        this.enrollmentViewModel.HICN = enrollment.medicareId
        this.enrollmentViewModel.APPFN = enrollment.firstName
        this.enrollmentViewModel.APPLN = enrollment.lastName
        this.enrollmentViewModel.APPDOB = enrollment.dateOfBirth
        this.enrollmentViewModel.CELLPHONE = enrollment.cellPhone || ''
        this.enrollmentViewModel.APPEMAIL = enrollment.email || ''
        this.enrollmentViewModel.APPGEN = enrollment.gender || ''
        this.enrollmentViewModel.APPMI = enrollment.middleInitial || ''
        this.enrollmentViewModel.MEDA = enrollment.medicarePartAEffectiveDate
        this.enrollmentViewModel.MEDB = enrollment.medicarePartBEffectiveDate
        this.enrollmentViewModel.SUFFIX = enrollment.suffixName || ''
        this.enrollmentViewModel.APPMI = enrollment.middleInitial || ''
        this.enrollmentViewModel.TITLE = enrollment.title
        this.enrollmentViewModel.APPPHONE = enrollment.primaryPhone || ''
    }
    onPrescriptionDrugValueChange(enrollment: EnrollmentViewModel) {
        this.enrollmentViewModel.OTHCVRG = enrollment.OTHCVRG
        this.enrollmentViewModel.OTHCVRGNAME = enrollment.OTHCVRGNAME
        this.enrollmentViewModel.OTHCVRGID = enrollment.OTHCVRGID
        this.enrollmentViewModel.OTHCVRGGRP = enrollment.OTHCVRGGRP
        this.enrollmentViewModel.COBBIN = enrollment.COBBIN
        this.enrollmentViewModel.COBPCN = enrollment.COBPCN
        this.enrollmentViewModel.COBEFFDT = enrollment.COBEFFDT
        this.enrollmentViewModel.COBTERMDT = enrollment.COBTERMDT
        this.enrollmentViewModel.LANG = enrollment.LANG
    }

    paymentOptionChanged(option: string) {
        this.paymentOption = this.enrollmentViewModel.PWO = option
    }

    paymentAccountChanged(paymentAccount: PaymentAccount) {
        this.paymentAccount = this.enrollmentViewModel.paymentAccount = paymentAccount
        this.enrollmentViewModel.ACCHOLDERNAME = paymentAccount.holderName
        this.enrollmentViewModel.ROUTINGNB = paymentAccount.routingNumber
        this.enrollmentViewModel.ACCOUNTNB = paymentAccount.number
        this.enrollmentViewModel.FININSTNAME = paymentAccount.institution
        this.enrollmentViewModel.EFTTYPE = paymentAccount.type || ''
    }

    setAccessibility(lAccessibility) {
        if (this.accessibilityValue != '' && this.accessibilityValue != undefined) {
            lAccessibility = this.accessibilityValue
        }
        if (lAccessibility == '1' || lAccessibility == '5') {
            this.accessibilityValue = '1'
            this.enrollmentViewModel.accessibility = '1'
        }
        if (lAccessibility == '2' || lAccessibility == '6') {
            this.accessibilityValue = '2'
            this.enrollmentViewModel.accessibility = '2'
        }
        if (lAccessibility == '4' || lAccessibility == '7') {
            this.accessibilityValue = '4'
            this.enrollmentViewModel.accessibility = '4'
        }
        if (lAccessibility == '8' || lAccessibility == '9') {
            this.accessibilityValue = '8'
            this.enrollmentViewModel.accessibility = '8'
        }
    }

    SetLanFormat(eob: string, selecteAccessibility: string): string {
        // Set  Access
        this.accessibilityValue = selecteAccessibility

        if (eob == 'EEOB' || eob == 'PEOB') {
            if (this.accessibilityValue != undefined && this.accessibilityValue != '') {
                if (this.accessibilityValue == '1') {
                    if (eob == 'EEOB') {
                        eob = '5'
                    } else {
                        eob = '1'
                    }
                }
                if (this.accessibilityValue == '2') {
                    if (eob == 'EEOB') {
                        eob = '6'
                    } else {
                        eob = '2'
                    }
                }
                if (this.accessibilityValue == '4') {
                    if (eob == 'EEOB') {
                        eob = '7'
                    } else {
                        eob = '4'
                    }
                }
                if (this.accessibilityValue == '8') {
                    if (eob == 'EEOB') {
                        eob = '9'
                    } else {
                        eob = '8'
                    }
                }
            }
        }
        return eob
    }
    submitForm() {
        this.ErrorMessages = [] as any[]
        this.enrollmentViewModel.PLANNAME = this.enrollmentViewModel.PLANTYPENAME
        if (!this.formValidation()) {
            this.enrollmentViewModel.STEEREDIND = true
            this.enrollmentViewModel.COMPLETEIND = false
            this.enrollmentViewModel.APPSIGNEDIND = true
            this.enrollmentViewModel.AUTHREPSIGNEDIND = false
            this.enrollmentViewModel.AGENTID = this.AGENTID
            this.enrollmentViewModel.AppStatus = 'In Progress'

            if (this.uniqueLink !== null && this.uniqueLink !== undefined) {
                this.enrollmentViewModel.AGENTFN = this.InProgessFName
                this.enrollmentViewModel.AGENTLN = this.InProgessLName
            } else {
                this.enrollmentViewModel.AGENTFN = this._global.currentUser.firstName
                this.enrollmentViewModel.AGENTLN = this._global.currentUser.lastName
            }

            this.enrollmentViewModel.Race = this._raceEthnicityComponent.submitRaceDynamic(this.enrollmentViewModel.Race)
            this.enrollmentViewModel.Ethnicity = this._raceEthnicityComponent.submitEthnicityDynamic(this.enrollmentViewModel.Ethnicity)

            this.enrollmentViewModel.displayEthnicity = this._raceEthnicityComponent.selectedEthnicityDynamicModel(
                this.enrollmentViewModel.selectedEthnicity
            )
            this.enrollmentViewModel.displayRace = this._raceEthnicityComponent.selectedRaceDynamicModel(this.enrollmentViewModel.selecteRace)

            this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
            this.enrollmentViewModel.SUBMISSIONTYPECODE = 'PROSPECT'
            this.enrollmentViewModel.DEX = 'AGNTP'
            this.enrollmentViewModel.AGENTDEX = 'EENRL'
            this.enrollmentViewModel.STEPCODE = '2'
            if (this.enrollmentViewModel.COBEFFDT === undefined) {
                this.enrollmentViewModel.COBEFFDT = null
            }
            if (this.enrollmentViewModel.COBTERMDT === undefined) {
                this.enrollmentViewModel.COBTERMDT = null
            }
            if (this.enrollmentViewModel.OTHCVRG.toUpperCase() === 'NO') {
                this.enrollmentViewModel.COBBIN = ''
                this.enrollmentViewModel.COBPCN = ''
                this.enrollmentViewModel.OTHCVRGNAME = ''
                this.enrollmentViewModel.OTHCVRGID = ''
                this.enrollmentViewModel.OTHCVRGGRP = ''
                this.enrollmentViewModel.COBTERMDT = null
                this.enrollmentViewModel.COBEFFDT = null
            }
            this.loading = true
            if (sessionStorage.getItem('GoodStandingParams') !== null) {
                this.goodStandingValues = JSON.parse(sessionStorage.getItem('GoodStandingParams')!)
                if (this.goodStandingValues !== undefined && this.goodStandingValues != null && !this.goodStandingValues.GoodStandingStatus) {
                    this.hasError = true
                    if (!this.goodStandingValues.CurriculumStatus) {
                        this.ErrorMessages.push(
                            this.enrollmentViewModel.AGENTNAME + 'has not passed training for' + this._global.selectedPlanYear + '<br/>'
                        )
                    }
                    if (!this.goodStandingValues.BackgroundCheckStatus) {
                        this.ErrorMessages.push(this.enrollmentViewModel.AGENTNAME + ' background check not approved.<br/>')
                    }
                    if (!this.goodStandingValues.LicenseStatus) {
                        this.ErrorMessages.push(this.enrollmentViewModel.AGENTNAME + ' does not have any valid license.<br/>')
                    }
                    return
                }
            }

            if (
                (this.enrollmentViewModel.EOB !== undefined &&
                    (this.enrollmentViewModel.EOB == '5' || this.enrollmentViewModel.EOB == '6' || this.enrollmentViewModel.EOB == '7')) ||
                this.enrollmentViewModel.EOB === '9'
            ) {
                this.enrollmentViewModel.EOB = 'EEOB'
            }
            if (this.enrollmentViewModel.EOB === undefined || (this.enrollmentViewModel.EOB !== 'EEOB' && this.enrollmentViewModel.EOB !== '3'))
                this.enrollmentViewModel.EOB = 'PEOB'

            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

            // Set  Access
            //this.enrollmentViewModel.EOB =  this.accessibilityComponent.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility);
            this.enrollmentViewModel.EOB = this.SetLanFormat(this.enrollmentViewModel.EOB, this.enrollmentViewModel.accessibility)

            this._enrollmentGateway.isValidAgent(this._global.currentUser.userProfileName).subscribe(
                (validAgentModel) => {
                    let isagentvalid = true

                    this.enrollmentViewModel.ADMINID = this._global.currentUser.userProfileId

                    if (this.enrollmentViewModel.historyStatus !== undefined && this.enrollmentViewModel.historyStatus === 'In Progress') {
                        if (this.enrollmentViewModel.AGENTID === undefined && this.enrollmentViewModel.AGENTID === '') {
                            this.enrollmentViewModel.AGENTID = String(this._global.currentUser.userProfileId)
                        }
                    } else {
                        this.enrollmentViewModel.AGENTID = String(this._global.currentUser.userProfileId)
                    }
                    this.enrollmentViewModel.INSURANCECOMPID = Number(this._global.currentUser.insuranceCompanyId)

                    //  console.log("Initial Method CUID :" + this.validAgentModel.CUID)

                    if (
                        validAgentModel.errorMessage !== undefined &&
                        validAgentModel.errorMessage !== null &&
                        validAgentModel.errorMessage !== '' &&
                        validAgentModel.errorMessage.length > 0
                    ) {
                        this.ErrorMessages.push(validAgentModel.errorMessage)
                        isagentvalid = false
                        this.loading = false
                    }

                    this.isValidAgent = isagentvalid
                    if (!this.isValidAgent) {
                        this.hasError = true
                        this.loading = false
                        this.focusableEleTop.nativeElement.focus()
                    } else {
                        this.hasError = false

                        this.CUID = validAgentModel.CUID

                        this.enrollmentViewModel.CUID = this.CUID

                        this.enrollmentViewModel.AGENTDETAILS = validAgentModel.CurrentUser
                        if (this.enrollmentViewModel.historyStatus !== undefined || this.enrollmentViewModel.historyStatus === 'In Progress') {
                            if (this.enrollmentViewModel.AGENTID === undefined && this.enrollmentViewModel.AGENTID === '') {
                                this.enrollmentViewModel.AGENTID = String(validAgentModel.agentID)
                                this.enrollmentViewModel.AGENTORGID = validAgentModel.AgentOrgId
                            }
                        } else {
                            this.enrollmentViewModel.AGENTID = String(validAgentModel.agentID)
                            this.enrollmentViewModel.AGENTORGID = validAgentModel.AgentOrgId
                        }

                        let appStateCode = this.enrollmentViewModel.APPST
                        let appZip = this.enrollmentViewModel.APPZIP
                        let mailStateCode = this.enrollmentViewModel.MAILST
                        let mailZip = this.enrollmentViewModel.MAILZIP
                        // if same address
                        if (this.enrollmentViewModel.SAMEADDRESS) {
                            mailStateCode = '0'
                            mailZip = '0'
                        }

                        this._enrollmentGateway.validateZip(appStateCode, appZip, mailStateCode, mailZip).subscribe(
                            (model: string[]) => {
                                if (model !== undefined && model !== null && model.length !== 0) {
                                    this.ErrorMessages = model
                                    this.hasError = true
                                    this.loading = false
                                    this.focusableEleTop.nativeElement.focus()
                                } else {
                                    this._enrollmentGateway.CheckDuplicateEnrollment(this.enrollmentViewModel).subscribe(
                                        (model: string[]) => {
                                            if (model !== undefined && model !== null && model.length !== 0) {
                                                this.ErrorMessages = model
                                                this.hasError = true
                                                this.focusableEleTop.nativeElement.focus()
                                                this.loading = false
                                            } else {
                                                this._enrollmentGateway.SubmitEnrollmentData(this.enrollmentViewModel).subscribe(
                                                    (model: SubmitEnrollmentDataResponse) => {
                                                        let response = model
                                                        if (response !== undefined) {
                                                            if (response.Errors !== undefined && response.Errors.length > 0) {
                                                                this.hasError = false

                                                                for (let i = 0; i < response.Errors.length; i++) {
                                                                    this.ErrorMessages.push(response.Errors[i].ErrorMessage)
                                                                }
                                                                this.hasError = true
                                                                this.loading = false
                                                                this.focusableEleTop.nativeElement.focus()
                                                            } else {
                                                                if (
                                                                    response.EnrollmentKey !== undefined &&
                                                                    response.EnrollmentKey !== '' &&
                                                                    response.EnrollmentKey !== null
                                                                ) {
                                                                    let selReasonCD = this.enrollmentViewModel.SEPREASONCD
                                                                    //this.enrollmentViewModel.SEPREASONCD = Number(this.enrollmentViewModel.ELECTIONTYPEID)
                                                                    this.loading = true
                                                                    if (
                                                                        this.enrollmentViewModel.UNIQUELINK !== undefined &&
                                                                        this.enrollmentViewModel.UNIQUELINK !== null &&
                                                                        this.enrollmentViewModel.UNIQUELINK !== ''
                                                                    ) {
                                                                        this._enrollmentGateway
                                                                            .UpdateElectronicEnrollmentData(this.enrollmentViewModel)
                                                                            .subscribe(
                                                                                (model: SubmitEnrollmentDataResponse) => {
                                                                                    this.enrollmentViewModel.SEPREASONCD = selReasonCD
                                                                                    let response = model
                                                                                    if (response.Errors) {
                                                                                        if (
                                                                                            response.Errors !== undefined &&
                                                                                            response.Errors.length > 0
                                                                                        ) {
                                                                                            this.hasError = false

                                                                                            for (let i = 0; i < response.Errors.length; i++) {
                                                                                                this.ErrorMessages.push(
                                                                                                    response.Errors[i].ErrorMessage
                                                                                                )
                                                                                            }

                                                                                            this.hasError = true
                                                                                            this.focusableEleTop.nativeElement.focus()
                                                                                        } else {
                                                                                            this.ErrorMessages.push(
                                                                                                'Error while submitting data, please try again.'
                                                                                            )
                                                                                            this.hasError = true
                                                                                            this.focusableEleTop.nativeElement.focus()
                                                                                        }
                                                                                    } else {
                                                                                        this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
                                                                                        this.router.navigate([
                                                                                            '/' + insCo + '/enrollment/e-application/stage2/1'
                                                                                        ])
                                                                                    }
                                                                                    this.loading = false
                                                                                },
                                                                                (err) => {
                                                                                    this.enrollmentViewModel.SEPREASONCD = selReasonCD
                                                                                    this.loading = false
                                                                                }
                                                                            )
                                                                    } else {
                                                                        this._enrollmentGateway
                                                                            .SubmitElectronicEnrollmentData(this.enrollmentViewModel)
                                                                            .subscribe(
                                                                                (model: SubmitEnrollmentDataResponse) => {
                                                                                    this.enrollmentViewModel.SEPREASONCD = selReasonCD
                                                                                    let response = model
                                                                                    if (response.Errors) {
                                                                                        if (
                                                                                            response.Errors !== undefined &&
                                                                                            response.Errors.length > 0
                                                                                        ) {
                                                                                            this.hasError = false

                                                                                            for (let i = 0; i < response.Errors.length; i++) {
                                                                                                this.ErrorMessages.push(
                                                                                                    response.Errors[i].ErrorMessage
                                                                                                )
                                                                                            }

                                                                                            this.hasError = true
                                                                                            this.focusableEleTop.nativeElement.focus()
                                                                                        } else {
                                                                                            this.ErrorMessages.push(
                                                                                                'Error while submitting data, please try again.'
                                                                                            )
                                                                                            this.hasError = true
                                                                                            this.focusableEleTop.nativeElement.focus()
                                                                                        }
                                                                                    } else {
                                                                                        this.enrollmentViewModel.UNIQUELINK = response.toString()
                                                                                        this.router.navigate([
                                                                                            '/' + insCo + '/enrollment/e-application/stage2/1'
                                                                                        ])
                                                                                    }
                                                                                    this.loading = false
                                                                                },
                                                                                (err) => {
                                                                                    this.enrollmentViewModel.SEPREASONCD = selReasonCD
                                                                                    this.loading = false
                                                                                }
                                                                            )
                                                                    }
                                                                } else {
                                                                    this.ErrorMessages.push('Error while submitting data, please try again.')
                                                                    this.hasError = true
                                                                    this.loading = false
                                                                    this.focusableEleTop.nativeElement.focus()
                                                                }
                                                            }
                                                        } else {
                                                            this.ErrorMessages.push('Error while submitting data, please try again.')
                                                            this.hasError = true
                                                            this.focusableEleTop.nativeElement.focus()
                                                        }
                                                    },

                                                    (err) => {
                                                        this.loading = false
                                                    }
                                                )
                                            }
                                        },
                                        (err) => {
                                            this.loading = false
                                        }
                                    )
                                }
                            },
                            (err) => {
                                this.loading = false
                            }
                        )
                    }
                },
                (err) => {
                    this.loading = false
                }
            )
        } else {
            this.focusableEleTop.nativeElement.focus()
        }
    }

    resetBankDeatils() {
        this.enrollmentViewModel.ACCHOLDERNAME = ''
        this.enrollmentViewModel.EFTTYPE = ''
        this.enrollmentViewModel.FININSTNAME = ''
        this.enrollmentViewModel.ROUTINGNB = ''
        this.enrollmentViewModel.ACCOUNTNB = ''

        this.paymentAccount.holderName = ''
        this.paymentAccount.institution = ''
        this.paymentAccount.number = ''
        this.paymentAccount.routingNumber = ''
        this.paymentAccount.type = null
        this.paymentAccount = {} as PaymentAccount
        this.enrollmentViewModel.paymentAccount = this.paymentAccount
    }

    formValidation(): boolean {
        this.hasError = false
        //let HICNregex = new RegExp('[1-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z 0-9][0-9](?![SLOIBZ])[A-Z](?![SLOIBZ])[A-Z][0-9][0-9]')

        //let validHICN = HICNregex.test(this.enrollmentViewModel.HICN)
        //if (!validHICN) {
        //    this.ErrorMessages.push('Invalid Medicare Number Format')
        //    this.hasError = true
        //}

        if (this.enrollmentViewModel.ELECTION !== undefined) {
            if (this.enrollmentViewModel.SEPREASONTEXT === undefined || this.enrollmentViewModel.SEPREASONTEXT === '') {
                this.ErrorMessages.push('Enrollment Criteria is required')
                this.hasError = true
            }
            if (this.enrollmentViewModel.ELECTION === 'Special') {
                if (this.dateField === true) {
                    if (this.enrollmentViewModel.SEPEFFDT === undefined || this.enrollmentViewModel.SEPEFFDT === null) {
                        this.ErrorMessages.push('SEP date is required')
                        this.hasError = true
                    }
                }
            }
        }
        if (this.enrollmentViewModel.APPADD1 === undefined || this.enrollmentViewModel.APPADD1 === '') {
            this.ErrorMessages.push('Street Address is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPZIP === undefined || this.enrollmentViewModel.APPZIP === '') {
            this.ErrorMessages.push('Zip is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.MAILZIP === undefined || this.enrollmentViewModel.MAILZIP === '') {
            this.ErrorMessages.push('Mailing Zip is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPCITY === undefined || this.enrollmentViewModel.APPCITY === '') {
            this.ErrorMessages.push('City is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.HICN === undefined || this.enrollmentViewModel.HICN === null || this.enrollmentViewModel.HICN === '') {
            this.ErrorMessages.push('Medicare Number is required')
            this.hasError = true
        } else if (this.enrollmentViewModel.HICN.indexOf('-') > -1) {
            this.ErrorMessages.push('Please enter Medicare Number without -')
            this.hasError = true
        }

        /*
        if (this.enrollmentViewModel.CURRENTGENDER == "4" && (this.enrollmentViewModel.CURRENTGENDEROTH == undefined
            || this.enrollmentViewModel.CURRENTGENDEROTH == '')) {
            this.ErrorMessages.push('Different Gender Identity Required')
            this.hasError = true

        }
        if (this.enrollmentViewModel.GENDERNPRONOUN == "4" && (this.enrollmentViewModel.GENDERNPRONOUNOTH == undefined
            || this.enrollmentViewModel.GENDERNPRONOUNOTH == '')) {
            this.ErrorMessages.push('Different Self-Identity is Required')
            this.hasError = true

        }
        */

        //let regexCityVal = new RegExp('^[a-zA-Z-]*$')
        let regexCityVal = /^[A-Za-z\s\-.]+$/

        if (this.enrollmentViewModel.APPCITY !== undefined || this.enrollmentViewModel.APPCITY !== '') {
            let isCityValid = regexCityVal.test(this.enrollmentViewModel.APPCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid City')
            }
        }

        if (this.enrollmentViewModel.APPST === undefined || this.enrollmentViewModel.APPST === '' || this.enrollmentViewModel.APPST === '0') {
            this.ErrorMessages.push('State is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILADD1 === undefined || this.enrollmentViewModel.MAILADD1 === '') {
            this.ErrorMessages.push('Mailing Address is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILCITY === undefined || this.enrollmentViewModel.MAILCITY === '') {
            this.ErrorMessages.push('Mailing City is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.MAILCITY !== undefined || this.enrollmentViewModel.MAILCITY !== '') {
            let isCityValid = regexCityVal.test(this.enrollmentViewModel.MAILCITY)
            if (!isCityValid) {
                this.hasError = true
                this.ErrorMessages.push('Please enter valid Mailing City')
            }
        }

        if (this.enrollmentViewModel.MAILST === undefined || this.enrollmentViewModel.MAILST === '' || this.enrollmentViewModel.MAILST === '0') {
            this.ErrorMessages.push('Mailing State is required')
            this.hasError = true
        }

        if (this.enrollmentViewModel.APPLN === undefined || this.enrollmentViewModel.APPLN === '') {
            this.ErrorMessages.push('Last Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPFN === undefined || this.enrollmentViewModel.APPFN === '') {
            this.ErrorMessages.push('First Name is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPDOB === undefined || this.enrollmentViewModel.APPDOB === null) {
            this.ErrorMessages.push('Date of Birth is required')
            this.hasError = true
        } else {
            let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY')
            if (dob.isSameOrBefore('12/31/1889')) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Date of Birth.')
            } else {
                if (!isMMDDYYYY(this.enrollmentViewModel.APPDOB.toString())) {
                    this.ErrorMessages.push('Date of Birth does not contain a valid Date')
                    this.hasError = true
                }
            }
        }
        // if (this.enrollmentViewModel.CELLPHONE === undefined || this.enrollmentViewModel.CELLPHONE === '') {
        //    this.ErrorMessages.push('Phone is required')
        //    this.hasError = true

        // }

        if (this.enrollmentViewModel.APPEMAIL === undefined || this.enrollmentViewModel.APPEMAIL === '') {
            this.ErrorMessages.push('Email Address is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPGEN === undefined || this.enrollmentViewModel.APPGEN === '') {
            this.ErrorMessages.push('Gender is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.APPDT === undefined || this.enrollmentViewModel.APPDT === null) {
            this.ErrorMessages.push('Application Date is required')
            this.hasError = true
        }
        //else {
        //    var d = new Date()
        //    if (this.enrollmentViewModel.APPDT.toDateString() !== d.toDateString()) {
        //        this.ErrorMessages.push('Application Date must remain as today\'s date')
        //        this.hasError = true
        //    }
        //}
        if (this.enrollmentViewModel.EFFDT === undefined || this.enrollmentViewModel.EFFDT === null) {
            this.ErrorMessages.push('Effective Date is required')
            this.hasError = true
        } else {
            if (this.enrollmentViewModel.EFFDT.getDate() != 1) {
                this.ErrorMessages.push('The Effective Date must fall on the first of the month.')
                this.hasError = true
            }
            if (this.enrollmentViewModel.EFFDT.getFullYear() != this._global.selectedPlanYear) {
                this.ErrorMessages.push('The Effective Date must be in the same year as the Plan Year')
                this.hasError = true
            }
            if (this.enrollmentViewModel.APPDT && this.enrollmentViewModel.EFFDT <= this.enrollmentViewModel.APPDT) {
                this.ErrorMessages.push('Application date must be prior to the effective date.')
                this.hasError = true
            }
            // var date = new Date()
            //if (this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() - 1) || this.enrollmentViewModel.EFFDT.getMonth() <= (date.getMonth() + 3)) {
            //    this.ErrorMessages.push('The Effective Date can be 1 month before the current month and 3 months after the current month.')
            //    this.hasError = true

            //}
        }
        if (this.enrollmentViewModel.PLANTYPE === undefined || this.enrollmentViewModel.PLANTYPE === '') {
            this.ErrorMessages.push('Plan Type is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === undefined || this.enrollmentViewModel.PWO === null || this.enrollmentViewModel.PWO === '') {
            this.ErrorMessages.push('Premium Payment is required')
            this.hasError = true
        }
        //if (this.enrollmentViewModel.EOB === undefined || this.enrollmentViewModel.EOB === '') {
        //    //this.ErrorMessages.push('EOB Preference is required')
        //    this.ErrorMessages.push('Paperless Documents preference is required')
        //    this.hasError = true
        //}

        if (this.enrollmentViewModel.PWO !== 'Automatic Bank Draft Withdrawal') {
            this.resetBankDeatils()
        }

        if (this.enrollmentViewModel.LANG === undefined || this.enrollmentViewModel.LANG === '') {
            this.ErrorMessages.push('Preferred Language is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.PWO === 'Automatic Bank Draft Withdrawal') {
            if (this.enrollmentViewModel.ACCHOLDERNAME === undefined || this.enrollmentViewModel.ACCHOLDERNAME === '') {
                this.ErrorMessages.push('Please enter valid Account Name')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCHOLDERNAME !== undefined &&
                this.enrollmentViewModel.ACCHOLDERNAME !== '' &&
                this.enrollmentViewModel.ACCHOLDERNAME !== null
            ) {
                let checkACCHOLDERNAME = this.enrollmentViewModel.ACCHOLDERNAME,
                    regexACCHOLDERNAMEVal = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isACCHOLDERNAMEValid = regexACCHOLDERNAMEVal.test(checkACCHOLDERNAME)
                if (!isACCHOLDERNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Name on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.EFTTYPE === undefined || this.enrollmentViewModel.EFTTYPE === '') {
                this.ErrorMessages.push('Please select Account type')
                this.hasError = true
            }
            if (this.enrollmentViewModel.FININSTNAME === undefined || this.enrollmentViewModel.FININSTNAME === '') {
                this.ErrorMessages.push('Please enter valid Financial Institution')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.FININSTNAME !== undefined &&
                this.enrollmentViewModel.FININSTNAME !== '' &&
                this.enrollmentViewModel.FININSTNAME !== null
            ) {
                let checkFININSTNAME = this.enrollmentViewModel.FININSTNAME,
                    regexFININSTNAME = new RegExp("^[a-zA-Z0-9 -. ']*$")
                let isFININSTNAMEValid = regexFININSTNAME.test(checkFININSTNAME)
                if (!isFININSTNAMEValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Financial Institution on Bank Account is invalid')
                }
            }
            if (this.enrollmentViewModel.ROUTINGNB === undefined || this.enrollmentViewModel.ROUTINGNB === '') {
                this.ErrorMessages.push('Please enter valid Routing Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                let checkROUTINGNB = this.enrollmentViewModel.ROUTINGNB,
                    regexROUTINGNB = new RegExp('^[0-9]*$')
                let isROUTINGNBValid = regexROUTINGNB.test(checkROUTINGNB)
                if (!isROUTINGNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing Number is invalid')
                }
            }
            if (
                this.enrollmentViewModel.ROUTINGNB !== undefined &&
                this.enrollmentViewModel.ROUTINGNB !== '' &&
                this.enrollmentViewModel.ROUTINGNB !== null
            ) {
                if (this.enrollmentViewModel.ROUTINGNB.length !== 9) {
                    this.hasError = true
                    this.ErrorMessages.push('Routing number must be 9 numbers')
                }
            }

            if (this.enrollmentViewModel.ACCOUNTNB === undefined || this.enrollmentViewModel.ACCOUNTNB === '') {
                this.ErrorMessages.push('Please enter valid Account Number')
                this.hasError = true
            }
            if (
                this.enrollmentViewModel.ACCOUNTNB !== undefined &&
                this.enrollmentViewModel.ACCOUNTNB !== '' &&
                this.enrollmentViewModel.ACCOUNTNB !== null
            ) {
                let checkACCOUNTNB = this.enrollmentViewModel.ACCOUNTNB,
                    regexACCOUNTNB = new RegExp('[0-9]{6}')
                let isACCOUNTNBValid = regexACCOUNTNB.test(checkACCOUNTNB)
                if (!isACCOUNTNBValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Account Number is invalid')
                }
            }
        }
        if (this.enrollmentViewModel.OTHCVRG === undefined || this.enrollmentViewModel.OTHCVRG === null || this.enrollmentViewModel.OTHCVRG === '') {
            this.ErrorMessages.push('Other Coverage is required')
            this.hasError = true
        }
        if (this.enrollmentViewModel.OTHCVRG === 'yes') {
            if (this.enrollmentViewModel.OTHCVRGNAME === undefined || this.enrollmentViewModel.OTHCVRGNAME === '') {
                this.ErrorMessages.push('Name of Other Coverage is required')
                this.hasError = true
            }
        }

        if (this.enrollmentViewModel.OTHCVRG === 'yes') {
            if (
                this.enrollmentViewModel.OTHCVRGNAME !== undefined &&
                this.enrollmentViewModel.OTHCVRGNAME !== '' &&
                this.enrollmentViewModel.OTHCVRGNAME !== null
            ) {
                let checkCoverageName = this.enrollmentViewModel.OTHCVRGNAME,
                    //regexCoverageNameVal = new RegExp('^[a-zA-Z]*$')
                    regexCoverageNameVal = /^[A-Za-z\s\-\' ]+$/

                let isCovnameValid = regexCoverageNameVal.test(checkCoverageName)
                if (!isCovnameValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Name is invalid')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGID !== undefined &&
                this.enrollmentViewModel.OTHCVRGID !== '' &&
                this.enrollmentViewModel.OTHCVRGID !== null
            ) {
                let checkCoverageID = this.enrollmentViewModel.OTHCVRGID,
                    regexCoverageIDVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovIDValid = regexCoverageIDVal.test(checkCoverageID)
                if (!isCovIDValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Id is invalid')
                }
            }
            if (
                this.enrollmentViewModel.OTHCVRGGRP !== undefined &&
                this.enrollmentViewModel.OTHCVRGGRP !== '' &&
                this.enrollmentViewModel.OTHCVRGGRP !== null
            ) {
                let checkCoverageGroup = this.enrollmentViewModel.OTHCVRGGRP,
                    regexCovGroupVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCovGroupValid = regexCovGroupVal.test(checkCoverageGroup)
                if (!isCovGroupValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Group is invalid')
                }
            }
            if (this.enrollmentViewModel.COBBIN !== undefined && this.enrollmentViewModel.COBBIN !== '' && this.enrollmentViewModel.COBBIN !== null) {
                let checkCOBBIN = this.enrollmentViewModel.COBBIN,
                    regexcheckCOBBINVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isRxBinValid = regexcheckCOBBINVal.test(checkCOBBIN)
                if (!isRxBinValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Bin is invalid')
                }
            }

            if (this.enrollmentViewModel.COBPCN !== undefined && this.enrollmentViewModel.COBPCN !== '' && this.enrollmentViewModel.COBPCN !== null) {
                let checkCOBPCN = this.enrollmentViewModel.COBPCN,
                    regexCOBPCNVal = new RegExp('^[a-zA-Z0-9 ]*$')
                let isCOBPCNValid = regexCOBPCNVal.test(checkCOBPCN)
                if (!isCOBPCNValid) {
                    this.hasError = true
                    this.ErrorMessages.push('Other Coverage Pcn is invalid ')
                }
            }
        }

        if (this.enrollmentViewModel.APPFN !== undefined && this.enrollmentViewModel.APPFN !== '' && this.enrollmentViewModel.APPFN !== null) {
            let checkFName = this.enrollmentViewModel.APPFN,
                regexFNameVal = new RegExp("^[a-zA-Z.' ]*$")
            let isFnameValid = regexFNameVal.test(checkFName)
            if (!isFnameValid) {
                this.hasError = true
                this.ErrorMessages.push('First Name is invalid')
            }
        }

        if (this.enrollmentViewModel.APPMI !== undefined && this.enrollmentViewModel.APPMI !== '' && this.enrollmentViewModel.APPMI !== null) {
            let checkMI = this.enrollmentViewModel.APPMI,
                regexMIVal = new RegExp('^[a-zA-Z ]*$')
            let isMiValid = regexMIVal.test(checkMI)
            if (!isMiValid) {
                this.hasError = true
                this.ErrorMessages.push('MI is invalid')
            }
        }
        if (this.enrollmentViewModel.APPLN !== undefined && this.enrollmentViewModel.APPLN !== '' && this.enrollmentViewModel.APPLN !== null) {
            let checkLName = this.enrollmentViewModel.APPLN,
                regexFNameVal = new RegExp("^[a-zA-Z.' -]*$")
            let isLnameValid = regexFNameVal.test(checkLName)
            if (!isLnameValid) {
                this.hasError = true
                this.ErrorMessages.push('Last Name is invalid')
            }
        }
        if (this.enrollmentViewModel.SUFFIX !== undefined && this.enrollmentViewModel.SUFFIX !== '') {
            let checkSuffix = this.enrollmentViewModel.SUFFIX,
                regexSuffixVal = new RegExp('^[a-zA-Z. 0-9]*$')
            let isSuffixValid = regexSuffixVal.test(checkSuffix)
            if (!isSuffixValid) {
                this.hasError = true
                this.ErrorMessages.push('Suffix is invalid')
            }
        }
        if (this.enrollmentViewModel.APPZIP !== undefined && this.enrollmentViewModel.APPZIP !== '' && this.enrollmentViewModel.APPZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Zip is invalid')
            }
        }

        if (this.enrollmentViewModel.MAILZIP !== undefined && this.enrollmentViewModel.MAILZIP !== '' && this.enrollmentViewModel.MAILZIP !== null) {
            let checkZipCode = this.enrollmentViewModel.APPZIP,
                regexVal = new RegExp('[0-9]{5}')
            let isZipCodeValid = regexVal.test(checkZipCode)
            if (!isZipCodeValid) {
                this.hasError = true
                this.ErrorMessages.push('Mailing Zip is invalid')
            }
        }

        if (
            this.enrollmentViewModel.APPPHONE !== undefined &&
            this.enrollmentViewModel.APPPHONE !== '' &&
            this.enrollmentViewModel.APPPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.APPPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Phone Number cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Phone Number must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }

        if (
            this.enrollmentViewModel.CELLPHONE !== undefined &&
            this.enrollmentViewModel.CELLPHONE !== '' &&
            this.enrollmentViewModel.CELLPHONE !== null
        ) {
            let checkOrgPhone = this.enrollmentViewModel.CELLPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkOrgPhone)) {
            } else {
                if (!this.isValidNumber(checkOrgPhone)) {
                    this.ErrorMessages.push('Cell Phone Number cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Cell Phone Number must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.LTCPHONE !== undefined &&
            this.enrollmentViewModel.LTCPHONE !== '' &&
            this.enrollmentViewModel.LTCPHONE !== null
        ) {
            let checkLTCPhone = this.enrollmentViewModel.LTCPHONE.replace(/-/g, '')
            if (/^\d{10}$/.test(checkLTCPhone)) {
            } else {
                if (!this.isValidNumber(checkLTCPhone)) {
                    this.ErrorMessages.push('Long-Term care facility phone cannot contain letters or special characters.')
                    this.hasError = true
                } else {
                    this.ErrorMessages.push('Long-Term care facility Phone must be exactly 10 numbers.')
                    this.hasError = true
                }
            }
        }
        if (
            this.enrollmentViewModel.APPEMAIL !== undefined &&
            this.enrollmentViewModel.APPEMAIL !== '' &&
            this.enrollmentViewModel.APPEMAIL !== null
        ) {
            let unicodeRange = '(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])'
            let checkOrgEmail = this.enrollmentViewModel.APPEMAIL.toLowerCase()
            //regexVal = new RegExp(
            //    `^` +
            //    `(` +
            //    `?:[a-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_\`{|}~-]+)*|"` +
            //    `${unicodeRange}*"` +
            //    `)` +
            //    `@` +
            //    `(` +
            //    `?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+` +
            //    `[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|` +
            //    `\\[` +
            //    `(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}` +
            //    `(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:${unicodeRange}+)` +
            //    `\\]` +
            //    `)` +
            //    `$`
            //)
            let isOrgEmailValid = this.isValidEmail(checkOrgEmail)
            if (!isOrgEmailValid) {
                this.hasError = true
                this.ErrorMessages.push('Invalid Email Address for Electronic Application')
            }
        }

        let dob = moment(this.enrollmentViewModel.APPDOB, 'MM/DD/YYYY', true)

        if (dob.isSameOrBefore('1889-12-31')) {
            this.hasError = false
            this.ErrorMessages.push('Invalid Date of Birth.')
        }

        return this.hasError
    }

    private isValidEmail(text: string): boolean {
        return /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(text)
    }
    private isValidNumber(text: string): boolean {
        return /^\d*$/.test(text)
    }

    ngOnDestroy() {
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
    }

    continueStep() {
        this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
        //  this.enrollmentViewModel.CUID = "1003"

        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        //  console.log("oncontinue: " + this.enrollmentViewModel)
        //  console.log("oncontinue CUID: " + this.enrollmentViewModel.CUID)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-application/stage2/' + '3'])
    }
    correctionStep() {
        this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-application/confirmation/' + '1'])
    }

    rejectStep() {
        this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-application/confirmation/' + '2'])
    }

    eobOptionChanged(option: boolean) {
        if (option === true) {
            //this.enrollmentViewModel.EOB = '3'
            this.enrollmentViewModel.EOB = 'EEOB'
        } else {
            this.enrollmentViewModel.EOB = 'PEOB'
            //this.enrollmentViewModel.EOB = 'N'
        }
    }
    emailChanged(option: string) {
        this.enrollmentViewModel.APPEMAIL = option
    }

    viewHistory() {
        this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-application/history'])
    }

    ngAfterViewInit() {
        //this.childOtherCov.loadOtherCoverage(this.otherCov)
        if (this.child !== undefined) {
            this.child.loadGoBackData()
        }
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.submitForm()
        }
    }
    GetTrainingURL() {
        /*
        this.trainingCertificatesGateway.LogintoCourseGuide(this._global.currentUser.userProfileName,
            this._global.selectedPlanYear).subscribe
            ((data) => {
                window.open(data, '_blank')
            })
        */
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.routers.navigate(['/' + insCo + '/training/trainingDetail'])
    }
    private setOrgname() {
        if (this._global.selectedPlanYear === 0 || this._global.selectedPlanYear === undefined) {
            if (sessionStorage.getItem('PLANYEAR') !== undefined) {
                this._global.selectedPlanYear = Number(sessionStorage.getItem('PLANYEAR'))
            }
        }
        if (Number(this._global.selectedPlanYear) === this._global.CurrentYear) {
            this.insuranceCompany = this._global.currentUser.insuranceCompanyName
        } else {
            this.insuranceCompany = this._global.insuranceCompanyNameAetna
        }
    }
}
